import { WidgetYearlyIndicatorComponent } from '@/components/widgets/widget-yearly-indicator/widget-yearly-indicator.component';
import { WidgetActionsStateComponent } from '@/features/action-plan/components/widget-actions-state/widget-actions-state';
import { WidgetBuildingActionSummaryComponent } from '@/features/action-plan/components/widget-building-action-summary/widget-building-action-summary';
import { Injectable, type Type } from '@angular/core';
import type { AbstractWidgetClass } from '../components/widgets/AbstractWidget.class';
import { WidgetMiniContractOptimizationComponent } from '../components/widgets/mini-widgets/widget-mini-contract-optimization/widget-mini-contract-optimization';
import { WidgetMiniInvoiceErrorsComponent } from '../components/widgets/mini-widgets/widget-mini-invoice-errors/widget-mini-invoice-errors';
import { WidgetMiniMissingInvoicesComponent } from '../components/widgets/mini-widgets/widget-mini-missing-invoices/widget-mini-missing-invoices';
import { WidgetBalanceTableComponent } from '../components/widgets/widget-balance-table/widget-balance-table';
import { WidgetBudgetVisionComponent } from '../components/widgets/widget-budget-vision/widget-budget-vision';
import { WidgetBuildingPerformantSitesComponent } from '../components/widgets/widget-building-performant-sites/widget-building-performant-sites';
import { WidgetContactListComponent } from '../components/widgets/widget-contact-list/widget-contact-list';
import { WidgetCustomPictureComponent } from '../components/widgets/widget-custom-picture/widget-custom-picture';
import { WidgetEnergyBalanceByUsageComponent } from '../components/widgets/widget-energy-balance-by-usage/widget-energy-balance-by-usage';
import { WidgetEnergyEfficiencyRatingComponent } from '../components/widgets/widget-energy-efficiency-rating/widget-energy-efficiency-rating';
import { WidgetEnergyExpenditureBalanceComponent } from '../components/widgets/widget-energy-expenditure-balance/widget-energy-expenditure-balance';
import { WidgetHomeFavSensorsComponent } from '../components/widgets/widget-home-fav-sensors/widget-home-fav-sensors';
import { WidgetHomeTilesComponent } from '../components/widgets/widget-home-tiles/widget-home-tiles';
import { WidgetHtmlFreestyleComponent } from '../components/widgets/widget-html-freestyle/widget-html-freestyle';
import { WidgetIpeTilesComponent } from '../components/widgets/widget-ipe-tiles/widget-ipe-tiles';
import { WidgetMonositeOnlyComponent } from '../components/widgets/widget-monosite-only/widget-monosite-only';
import { WidgetNodeInfoComponent } from '../components/widgets/widget-node-info/widget-node-info';
import { WidgetSectionTitleComponent } from '../components/widgets/widget-section-title/widget-section-title';
import { WidgetSingleSensorComponent } from '../components/widgets/widget-single-sensor/widget-single-sensor';
import { LegacyWidgetCode } from './rights.constants';

/**
 * This widget is separated from the WidgetProvider to avoid circular-dependencies
 * Indeed, to instanciate widgets, the WidgetProvider needs reference to the widget classes,
 * thus creating circular dependencies if the WidgetProvider is used in these widgets
 */
@Injectable({
    providedIn: 'root'
})
export class WidgetClassStaticProvider {
    static getWidgetFromLegacyWidgetCode(widgetRight: LegacyWidgetCode): Type<AbstractWidgetClass<string, any>> | undefined {
        switch (widgetRight) {
            case LegacyWidgetCode.WDGT_NODE_INFO_RIGHT_ACCESS: {
                return WidgetNodeInfoComponent;
            }

            case LegacyWidgetCode.WDGT_ENERGY_BALANCE_BY_USAGE_RIGHT_ACCESS: {
                return WidgetEnergyBalanceByUsageComponent;
            }

            case LegacyWidgetCode.WDGT_ACTIONS_RIGHT_ACCESS: {
                return WidgetActionsStateComponent;
            }

            case LegacyWidgetCode.WDGT_ENERGY_BALANCE_TABLE_RIGHT_ACCESS: {
                return WidgetBalanceTableComponent;
            }

            case LegacyWidgetCode.WDGT_BUILDING_PERFORMANT_SITES_RIGHT_ACCESS: {
                return WidgetBuildingPerformantSitesComponent;
            }

            case LegacyWidgetCode.WDGT_BUILDING_ACTION_SUMMARY_RIGHT_ACCESS: {
                return WidgetBuildingActionSummaryComponent;
            }

            case LegacyWidgetCode.WDGT_ENERGY_EXPENDITURE_BALANCE_RIGHT_ACCESS: {
                return WidgetEnergyExpenditureBalanceComponent;
            }

            case LegacyWidgetCode.WDGT_HOME_FAV_SENSORS_RIGHT_ACCESS: {
                return WidgetHomeFavSensorsComponent;
            }

            case LegacyWidgetCode.WDGT_HOME_TILES_RIGHT_ACCESS: {
                return WidgetHomeTilesComponent;
            }

            case LegacyWidgetCode.WDGT_ENERGY_EFFICIENTY_RATING_RIGHT_ACCESS: {
                return WidgetEnergyEfficiencyRatingComponent;
            }

            case LegacyWidgetCode.WDG_IPE_TILES: {
                return WidgetIpeTilesComponent;
            }

            case LegacyWidgetCode.WDGT_SECTION_TITLE: {
                return WidgetSectionTitleComponent;
            }

            case LegacyWidgetCode.WDG_BUDGET_VISION_RIGHT_ACCESS: {
                return WidgetBudgetVisionComponent;
            }

            case LegacyWidgetCode.WDG_MONOSITE_ONLY_RIGHT_ACCESS: {
                return WidgetMonositeOnlyComponent;
            }

            case LegacyWidgetCode.WDGT_MINI_CONTRACT_OPTIMIZATION: {
                return WidgetMiniContractOptimizationComponent;
            }

            case LegacyWidgetCode.WDGT_MINI_MISSING_INVOICES: {
                return WidgetMiniMissingInvoicesComponent;
            }

            case LegacyWidgetCode.WDGT_MINI_INVOICE_ERRORS: {
                return WidgetMiniInvoiceErrorsComponent;
            }

            case LegacyWidgetCode.WDGT_HTML_FREESTYLE: {
                return WidgetHtmlFreestyleComponent;
            }

            case LegacyWidgetCode.WDGT_CONTACT_LIST: {
                return WidgetContactListComponent;
            }

            case LegacyWidgetCode.WDGT_CUSTOM_PICTURE: {
                return WidgetCustomPictureComponent;
            }

            case LegacyWidgetCode.WDGT_SINGLE_SENSOR: {
                return WidgetSingleSensorComponent;
            }

            case LegacyWidgetCode.WDGT_YEARLY_INDICATOR: {
                return WidgetYearlyIndicatorComponent;
            }
        }
    }
}
